// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HPZKoX3tXXK0hBRFpz6W{display:flex;flex-direction:column;gap:32px}.UMlKhOR2lbGt23r7STIY{flex:1}.NGz1BEnQJFUJVmSuTVyI{align-self:flex-start}", "",{"version":3,"sources":["webpack://./src/pages/cp/conversations/channel/webchat/general/index.module.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CACA,qBAAA,CACA,QAAA,CAGJ,sBACI,MAAA,CAGJ,sBACI,qBAAA","sourcesContent":[".root {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n}\n\n.select {\n    flex: 1;\n}\n\n.submitButton {\n    align-self: flex-start;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "HPZKoX3tXXK0hBRFpz6W",
	"select": "UMlKhOR2lbGt23r7STIY",
	"submitButton": "NGz1BEnQJFUJVmSuTVyI"
};
export default ___CSS_LOADER_EXPORT___;
